module.exports = __webpack_public_path__ + "static/img/hover-iocn72.199aaab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn72.svg
// module id = g37B
// module chunks = 3